<template>
<div class=" my-2" ref="functionsElement">
    <h1>
      Fonctions
    </h1>

    <draggable :group="'functions-' + id" :list="currentFunctions" class="list-group" handle=".handle" @update="updateOrder">
      <div v-for="(func, functionIdx) in currentFunctions" :key="func.uid"
        class="py-1">

        <fonction_excel :size="size" :ref="'f' + (func.uid)" @play="play" @star="toggleFunctionStar" :fonctionsFav="userDetails.fonctionsFav || []" :availableColumnsList="availableColumnsList" @update="updateFunction" @del="delFunction" :errorObject="errorObject" :func="func" :idx="functionIdx"></fonction_excel>

      </div>
    </draggable>

    <div class="pt-2">
      <b-dropdown right variant="success" class="" @show="onDropdownShow">
        
        <template #button-content>
          Ajouter une <span class=" italic text-2xl">
            f
          </span>
          (x)
        </template>
        <div class="px-2 pt-1 pb-1">
          <input
            ref="functionSearch"
            v-model="functionSearchQuery"
            type="text"
            placeholder="Rechercher..."
            class="form-control form-control-sm"
            @click.stop
          />
        </div>
        <div class=" overflow-y-scroll max-h-72">

          <template v-if="faveFunctionTemplatesFiltered.length > 0">
            <b-dropdown-header class=" font-bold">
              Favoris
            </b-dropdown-header>
            <b-dropdown-item v-for="(faveFuncTemplate, idx) in faveFunctionTemplatesFiltered"
              :key="'text-fav-function-template-'+idx"
              :title="faveFuncTemplate.description || ''"
              @click="() => addFunction(faveFuncTemplate)">
              {{ faveFuncTemplate.title }}
            </b-dropdown-item>
            <b-dropdown-divider></b-dropdown-divider>
          </template>

          <b-dropdown-item v-for="(functionTemplate, idx) in sortedFunctionTemplatesFiltered"
            :key="'text-function-template-'+idx"
            :title="functionTemplate.description || ''"
            @click="() => addFunction(functionTemplate)">
            {{ functionTemplate.title }}
          </b-dropdown-item>

          <b-dropdown-item v-if="sortedFunctionTemplatesFiltered.length === 0 && faveFunctionTemplatesFiltered.length === 0" disabled>
            Aucun résultat
          </b-dropdown-item>
        </div>
      </b-dropdown>
    </div>

    <div v-for="(error, key) in errorObject" :key="key" class=" pt-1">
      <span v-if='currentFunctions[key]' class=" text-red-700" :style="currentFunctions[key].isRunning ? '': 'opacity: 0.5'"><b>Erreur sur fonction {{ parseInt(key) + 1 }} ({{currentFunctions[key].title}}): </b>{{ error.msg }}</span>
    </div>
  </div>
</template>

<script>
	import uniqueId from "lodash.uniqueid";
    import draggable from "vuedraggable";
    import { uuid } from "vue-uuid";

    import FunctionBlockToJS from "../../services/FunctionBlockToJS.js";
    import fonction_excel from "./fonction_excel.vue";
    import users from "../../services/users.js";

    var clone = require("clone");

    export default {
		components: {
            fonction_excel,
            draggable
        },
        props: {
            editorRef: {
                default: () => {}
            },
            availableColumns: {
				default: () => [],
			},
            initialValue: {
				default: () => {},
			},
            prevData: {
				default: () => [],
            },
            idx: {
                default: 0
            },
            size: {}
        },
		data() {
			return {
                id: uniqueId(),
                functionSearchQuery: "",

                functionGroups: [
                    "Texte",
                    "Parsing",
                    "Organisation",
                    "Date",
                    "Calcul"
                ],
                functionTemplates: [],
                optionsCascaderSelect: [],
                user: {},
                userDetails: {},
                errorObject: {},
                currentFunctions: [],
                functionTabulatorSize: 0,
                availableColumnsList: [],
                sortedFunctionTemplates: [],
                play_idx: -1
            }
        },
        computed: {
            faveFunctionTemplates() {
                if (this.userDetails.fonctionsFav === undefined) {
                    return [];
                }
                let faveFunctionTemplates = this.functionTemplates.filter((f) => this.userDetails.fonctionsFav.includes(f.functionKey));

                // sort by title
                return faveFunctionTemplates.sort((a, b) => {
                    return a.title.localeCompare(b.title);
                });
            },
            faveFunctionTemplatesFiltered() {
                const q = this.functionSearchQuery.toLowerCase().trim();
                if (!q) return this.faveFunctionTemplates;
                // Recherche sur le nom de la fonction uniquement (pas sur la description,
                // qui peut contenir des mots comme "colonne" pour des fonctions non liées).
                return this.faveFunctionTemplates.filter(f => f.title.toLowerCase().includes(q));
            },
            sortedFunctionTemplatesFiltered() {
                const q = this.functionSearchQuery.toLowerCase().trim();
                if (!q) return this.sortedFunctionTemplates;
                return this.sortedFunctionTemplates.filter(f => f.title.toLowerCase().includes(q));
            }
        },
		watch: {
			currentFunctions: {
				deep: true,
				handler(newVal) {
                    this.setJSONSchema(newVal);
				},
			},
		},
		methods: {
            onDropdownShow() {
                this.functionSearchQuery = "";
                this.$nextTick(() => {
                    if (this.$refs.functionSearch) this.$refs.functionSearch.focus();
                });
            },
            updateOrder()
            {
                console.log("update order")
                this.errorObject = {};

                for (let i = 0; i < this.currentFunctions.length; i++) {
                    if (this.$refs["f" + (this.currentFunctions[i].uid)] && this.$refs["f" + (this.currentFunctions[i].uid)][0])
                    {
                        this.$refs["f" + (this.currentFunctions[i].uid)][0].setIsRunning(true);
                        this.$refs["f" + (this.currentFunctions[i].uid)][0].setData([]);;
                        this.$refs["f" + (this.currentFunctions[i].uid)][0].setShowFunctionTabulator(false)
                    }
                }
            },
            async play(idx)
            {
                console.log("play " + idx)
                this.errorObject = {};
                var error = false;

                // the first x functions are now running, not the others
                for (let i = 0; i < this.currentFunctions.length; i++) {
                    let currentFunc = this.currentFunctions[i];
                    if (i <= idx) {
                        this.$refs["f" + (this.currentFunctions[i].uid)][0].setIsRunning(true);
                        this.currentFunctions[i].isRunning = true;

                        if (this.functionHasError(currentFunc, i)) {
                            error = true;
                        }

                        console.log("Current func: ", currentFunc);
                        // perform error handling here
                        console.log("Current func origin: ", currentFunc.origin);

                    } else {
                        this.functionHasError(currentFunc, i);
                        this.$refs["f" + (this.currentFunctions[i].uid)][0].setIsRunning(false);
                        this.currentFunctions[i].isRunning = false;
                    }
                }

                console.log(error)

                if (error)
                    return;

                for (var i = 0; i < this.currentFunctions.length; i++)
                {
                    this.$refs["f" + (this.currentFunctions[i].uid)][0].setData([]);
                    if (i == idx)
                    {
                        this.$refs["f" + (this.currentFunctions[i].uid)][0].setShowFunctionTabulator(true);
                        //this.currentFunctions[i].showFunctionTabulator = true;
                    }
                    else
                    {
                        this.$refs["f" + (this.currentFunctions[i].uid)][0].setShowFunctionTabulator(false);
                        //this.currentFunctions[i].showFunctionTabulator = false;
                    }
                }

                this.play_idx = idx;

                // emit a test event
                var self = this;

                self.$emit("TestFunctions", this.currentFunctions);
            },
            async toggleFunctionStar(title, fav)
            {
                if (this.userDetails.fonctionsFav !== undefined) {
                    let index = this.userDetails.fonctionsFav.indexOf(title);
                    if (index > -1) {
                        this.userDetails.fonctionsFav.splice(index, 1);
                    }
                } else {
                    this.$set(this.userDetails, 'fonctionsFav', []);
                }

                // if function is not in userDetails, add it
                if (fav) {
                    this.userDetails.fonctionsFav.push(title);
                }

                this.user.details = this.userDetails;

                console.log(this.user)

                let result = await users.updateUserSelf(this.user, null);
                console.log("Updated user result: ", result);

                // update cascader select options
            },
            addFunction(functionTemplate)
            {                    
                console.log("addFunction")

                let isStarred = this.userDetails.fonctionsFav ? this.userDetails.fonctionsFav.includes(functionTemplate.functionKey) : false;

                this.currentFunctions.push(clone({...functionTemplate, isRunning: true, isStarred: isStarred, uid: this.$uuid.v4()}));
            },
            delFunction(idx)
            {                
                console.log("delFunction")
                this.currentFunctions.splice(idx, 1)
                
                this.errorObject = {};

                for (let i = 0; i < this.currentFunctions.length; i++) {
                    if (this.$refs["f" + (this.currentFunctions[i].uid)] && this.$refs["f" + (this.currentFunctions[i].uid)][0])
                    {
                        this.$refs["f" + (this.currentFunctions[i].uid)][0].setData([]);
                        this.$refs["f" + (this.currentFunctions[i].uid)][0].setShowFunctionTabulator(false);
                    }
                }
            },
            updateFunction(f, idx)
            {
                console.log("updateFunction")
                console.log(f)
                this.$set(this.currentFunctions, idx, f);
            },
            getCodeForFunction(func, toHtml = true)
            {
                console.log("getCodeForFunction")
                let functionResult = FunctionBlockToJS.convertFunctionBlockToJS(func, toHtml);
                return functionResult;
            },
            setJSONSchema(functions)
            {
                let schema = clone(this.initialValue);

                schema.functionCode = [];

                // aggregate all the code here
                let fullCode = "";
                for (let i = 0; i < functions.length; i++) {
                    let func = functions[i];
                    let codeForFunction = this.getCodeForFunction(func, false);

                    // par défaut on lance tout, mais on peut décider lesquels on ajoute
                    schema.functionCode.push(codeForFunction.safeCode);

                    fullCode += codeForFunction.safeCode;
                }

                schema.code = fullCode;
                // console.log("Final code: ", fullCode);

                schema.fonctions = functions;

                // console.log("schema: ", clone(schema));
                this.editorRef.setValue(schema);
            },
            getFunctions()
            {
                return this.currentFunctions;
            },
            editor_ready()
            {
                var editorValue = this.editorRef.getValue()
                var fonctions = (editorValue && editorValue.fonctions) ? editorValue.fonctions : [];

                for (var i = 0; i < fonctions.length; i++)
                {
                    if (!fonctions[i].uid)
                        fonctions[i].uid = this.$uuid.v4();
                }

                this.currentFunctions = fonctions;
            },
            setNewColumns(newColumns)
            {
                console.log("editor_ready")
                this.availableColumnsList = newColumns;
            },
            setPlayTestResult(result)
            {
                console.log("setPlayTestResult")

                console.log(result)

                console.log(this.play_idx);

                if (this.play_idx >= 0 && this.play_idx < this.currentFunctions.length)
                {
                    console.log("setData")
                    console.log(this.$refs["f" + (this.currentFunctions[this.play_idx].uid)])
                    this.$refs["f" + (this.currentFunctions[this.play_idx].uid)][0].setData(result);
                }
            },
            functionHasError(func, i)
            {
                let currentFunc = func;

                if (currentFunc.origin !== undefined && (currentFunc.origin.length === 0 || currentFunc.origin.some(origin => origin.value === ""))) {
                    // set error at index idx to "you must fill out the origin"
                    this.errorObject[i] = {msg: "Vous devez remplir l'origine"};
                    return true;
                }

                if (currentFunc.minArguments !== undefined && currentFunc.arguments.length < currentFunc.minArguments) {
                    this.errorObject[i] = {msg: `Vous devez remplir au moins ${currentFunc.minArguments} ${currentFunc.minArguments > 1 ? "arguments" : "argument"}`};
                    return true;
                }

                if (currentFunc.requiredArguments !== undefined) {
                    for (const requiredArg of currentFunc.requiredArguments) {
                        let foundArg = currentFunc.arguments.find(arg => arg.argumentKey === requiredArg.argumentKey);
                        console.log(requiredArg)
                        if (foundArg === undefined || (!requiredArg.empty && foundArg.value === "")) {
                            this.errorObject[i] = {msg: `Vous devez remplir l'argument requis: '${requiredArg.name}'`};
                            return true;
                        }
                    };
                }

                if (currentFunc.targetRequired === true) {
                    console.log("Currentfunc.target: ", currentFunc.target);
                    if (currentFunc.target === undefined || currentFunc.target.length === 0 || currentFunc.target.some(target => target.value === "")) {
                        this.errorObject[i] = {msg: "Vous devez remplir la destination"};
                        return true;
                    }
                }

                return false;
            },
            validateFunctionsForStep()
            {
                this.errorObject = {};
                var error = false;

                for (let i = 0; i < this.currentFunctions.length; i++) {
                    let currentFunc = this.currentFunctions[i];

                    if (this.functionHasError(currentFunc, i) && currentFunc.isRunning) {
                        var error = true;
                    }
                }

                if (error)
                {
                    return false;
                }

                return true;
            }
        },
        mounted: async function () {
            var self = this;

            let response = await users.getSelf(true);

            this.user = response.user;
            this.userDetails = this.user.details;
            this.availableColumnsList = clone(this.availableColumns);
            this.functionTemplates = FunctionBlockToJS.templates
            this.sortedFunctionTemplates = this.functionTemplates.sort((a, b) => {
                return a.title.localeCompare(b.title);
            });
        }
    }
</script>